<template>
  <div @click="handleClick"> 
    <!-- Navbar -->
    <NavbarComponent v-if="showNavbar" />
        <BienvenidaPage v-if="showBienvenida" />

    <musicaFondo v-if="showmusicaFondo" />
    <mispadres v-if="showmispadres" />
    <faltan v-if="showfaltan" />

    <!-- Imagen de portada -->
    <quotemensaje v-if="showquotemensaje" />
    <intermedio v-if="showintermedio" />

    <dondeycuando v-if="showdondeycuando" />

    <imagenprimera v-if="showimagenprimera" />

    <carruselComponent v-if="showcarrusel" />

    <itinerario v-if="showitinerario" />

    <mensajeregalos v-if="showmensajeregalos" />

    <!-- Comprobar si idInvitado es válido antes de mostrar el componente InvitadoEvento -->
    <Codigovestimenta v-if="showcodigovestimenta" />
    <mesaRegalos v-if="showmesaRegalos" />
    <Mensajefinal v-if="showmensajefinal" />
    <carrusel3 v-if="showcarrusel3" />
    <imagensegunda v-if="showimagensegunda" />
    <hospedaje2 v-if="showhospedaje2" />

    <InvitadoEvento 
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />
  
    <Carruselfina v-if="showcarrusefinal" />

    <blogevento
      v-if="showblogevento"
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />
 
    <hashtag
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />
    <carruselcomponent2 v-if="showcarrusel2" />

    <imgfinal v-if="showimgfinal" />
    <img_fixed v-if="showimg_fixed" />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import NavbarComponent from './narvar.vue';
import BienvenidaPage from './BienvenidaPage.vue';
import imagenprimera from './imagenprimera.vue';
import dondeycuando from './dondeycuando.vue';
import quotemensaje from './quotemensaje.vue';
import itinerario from './itinerario.vue';
import carruselComponent from './carruselComponent.vue';
import mensajeregalos from './mensajeregalos.vue';
import InvitadoEvento from './invitado_evento.vue';
import blogevento from './blog_evento.vue';
import imgfinal from './imgfinal.vue';
import img_fixed from './img_fixed.vue';
import musicaFondo from './musica_fondo.vue';
import mesaRegalos from './regalos';
import carruselcomponent2 from './carruselcomponent2.vue';
import Carruselcomponent2 from './carruselcomponent2.vue';
import faltan from './faltan.vue';
import carrusel3 from './carrusel3.vue';
import hospedaje2 from './hospedaje2.vue';
import codigovestimenta from './codigovestimenta.vue';
import imagensegunda from './imagenSegunda.vue';
import Carruselfina from './carruselfina.vue';
import mispadres from './mispadres.vue';
import Mensajefinal from './mensajefinal.vue';
import intermedio from './intermedio.vue';
import hashtag from './hashtag.vue';

export default {
  name: 'BaseB',
  components: {
    NavbarComponent,
    BienvenidaPage,
    Carruselfina,
    imagenprimera,
    Mensajefinal,
    imagensegunda,
    faltan,
    dondeycuando,
    itinerario,
    carrusel3,
    hashtag,
    hospedaje2,
    carruselComponent,
    carruselcomponent2,
    mensajeregalos,
    mispadres,
    mesaRegalos,
    InvitadoEvento,
    intermedio,
    quotemensaje,
    blogevento,
    imgfinal,
    codigovestimenta,
    img_fixed,
    musicaFondo,
    Carruselcomponent2,
  },
  setup() {
    const showNavbar = ref(false);
    const showBienvenida = ref(false);
    const showimagenprimera = ref(false);
    const showdondeycuando = ref(false);
    const showcarrusel3 = ref(false);
    const showitinerario = ref(false);
    const showcarrusel = ref(false);
    const showcarrusefinal = ref(false);
    const showmensajeregalos = ref(false);
    const showmesaRegalos = ref(false);
    const showInvitadoEvento = ref(false);
    const showquotemensaje = ref(false);
    const showhashtag = ref(false);
    const showhospedaje2 = ref(false);
    const showblogevento = ref(false);
    const showimgfinal = ref(false);
    const showimg_fixed = ref(false);
    const showmusicaFondo = ref(false);
    const showcodigovestimenta = ref(false);
    const showfaltan = ref(false);
    const showcarrusel2 = ref(false);
    const showmispadres = ref(false);
    const showimagensegunda = ref(false);
    const showintermedio = ref(false);
    const showmensajefinal = ref(false);

    // Obtener parámetros de la ruta
    const route = useRoute();
    const idInvitado = ref(Number(route.params.idInvitado) || undefined);
    const idFestejado = ref(Number(route.params.idFestejado) || undefined);
    const nombreVariable = ref(route.params.nombre);

    // Validaciones
    const isValidIdInvitado = computed(() => {
      return !isNaN(idInvitado.value) && idInvitado.value !== undefined;
    });

    // (FIX de typo) usar idFestejado correctamente
    const isValidFestejado = computed(() => {
      return !isNaN(idFestejado.value) && idFestejado.value !== undefined;
    });

    // Observa cambios en la ruta
    watch(() => route.params.idInvitado, (newId) => {
      idInvitado.value = Number(newId);
    });

    watch(() => route.params.idFestejado, (newId) => {
      idFestejado.value = Number(newId);
    });

    watch(() => route.params.nombre, (newNombre) => {
      nombreVariable.value = newNombre;
    });

    // Mostrar todo DESDE EL INICIO (sin esperar click)
    const handleClick = () => {
      showNavbar.value = true;
      showBienvenida.value = true;
      showimagenprimera.value = true;
      showdondeycuando.value = true;
      showitinerario.value = true;
      showhashtag.value = true;
      showhospedaje2.value = true;
      showcodigovestimenta.value = true;
      showcarrusel.value = true;
      showimagensegunda.value = true;
      showmensajeregalos.value = true;
      showmesaRegalos.value = true;
      showcarrusefinal.value = true;
      showmispadres.value = true;
      showInvitadoEvento.value = true;
      showquotemensaje.value = true;
      showmensajefinal.value = true;
      showcarrusel3.value = true;
      showfaltan.value = true;
      showblogevento.value = true;
      showcarrusel2.value = true;
      showimgfinal.value = true;
      showintermedio.value = true;
      showimg_fixed.value = true;
      showmusicaFondo.value = true;
    };

    onMounted(() => {
      // Ejecutar una vez al iniciar para que se vea todo sin click
      handleClick();
      // Si quieres mantener el comportamiento por click adicional, descomenta:
      // document.addEventListener('click', handleClick);
    });

    onUnmounted(() => {
      // Si activaste el listener anterior, aquí lo quitas:
      // document.removeEventListener('click', handleClick);
    });

   return { showNavbar,
     showimg_fixed, isValidIdInvitado, idFestejado,
      hashtag, showInvitadoEvento, nombreVariable, showmusicaFondo,
     isValidFestejado, // Computed que indica si el idInvitado es válido handleClick, };
  }
} };
</script>

<style scoped>
/* Estilos globales para el contenedor */
</style>
